<template>
  <div v-if="isModalActive" class="il-customs-fee">
    <div class="overlay"></div>
    <div class="window flex flex-col gap-6">
      <div class="window-top flex justify-between">
        <div class="content flex flex-col gap-2">
          <div class="title lg1024:text-2xl text-xl font-medium">
            {{ $t(modalTexts.titleKey) }}
          </div>
          <div class="text" v-html="customsNotification"></div>
        </div>
        <div class="close cursor-pointer" @click="redirectToBasket">
          <CloseIcon />
        </div>
      </div>
      <div class="window-bottom flex flex-col gap-6">
        <hr class="hr" />
        <div class="flex justify-end">
          <UiButton class="il-customs-fee__button" @click="acceptAndClose">
            {{ $t(modalTexts.buttonKey) }}
          </UiButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import store from '../store'
import CloseIcon from './svg/CloseIcon.vue'
import UiButton from './ui/UiButton.vue'

const currentCountry = computed(() =>
  store.state.IS_COUNTRY_GLOBAL
    ? store.state.CUR_LOCATION.CODE
    : store.state.CUR_LOCATION.ALPHA2
)
const isModalActive = ref(false)
const accepted = ref(false)

// Текст уведомления приходит с бэка (/init → CUSTOMS_NOTIFICATIONS)
// и сам является признаком показа попапа: null — попап не показываем
const customsNotification = computed(() => store.state.CUSTOMS_NOTIFICATIONS)

const showModal = () => {
  isModalActive.value = true
  document.body.style.overflowY = 'hidden'
}

watch(
  customsNotification,
  (text) => {
    if (!text || isModalActive.value) return
    showModal()
  },
  { immediate: true }
)

const acceptAndClose = () => {
  accepted.value = true
  isModalActive.value = false
  document.body.style.overflowY = 'auto'
}

const redirectToBasket = () => {
  window.location.href = '/basket/'
}

const modalTexts = computed(() => {
  const code = currentCountry.value.toLowerCase()
  return {
    titleKey: `${code}_feemodal_title`,
    buttonKey: `${code}_feemodal_button`,
  }
})
</script>

<style lang="scss" scoped>
.il-customs-fee {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  height: 100dvh;

  .window {
    width: 100%;
    max-width: 520px;
    background: var(--st-content-background-color-default-solid-normal, #fff);
    border-radius: var(--st-selectable-borderRadius-size-2xl, 16px);
    border: 1px solid var(--st-content-border-color-neutral-onsubtle, #e5ecf1);
    padding: 24px;
    box-shadow:
      0px 4px 8px -2px rgba(4, 8, 13, 0.12),
      0px 16px 24px -4px rgba(4, 8, 13, 0.12);
    z-index: 20000;
    position: relative;
    max-height: 100%;

    // Текст занимает всю доступную высоту окна и скроллится сам,
    // блок с кнопкой не сжимается
    .window-top {
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
    }

    .window-bottom {
      flex: 0 0 auto;
    }

    p {
      margin-bottom: 1rem;
    }

    .button {
      width: auto !important;
    }
  }

  .text :deep(a) {
    color: #e21f1f;
  }
}
</style>
